import { render, staticRenderFns } from "./CodigosDescuento.vue?vue&type=template&id=71721396"
import script from "./CodigosDescuento.vue?vue&type=script&lang=js"
export * from "./CodigosDescuento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports